/*
 * @Author: Vanny
 * @Date: 2020-05-16 17:48:13
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-16 20:58:54
 * @Description: 下载中心 - 仓库
 */
import { delay } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { message } from 'antd';
import { isEqual } from 'lodash';
import { $t } from 'src/tools'

import * as downApi from '../../services/downApi';

const initialState = {
  // 导出历史是否loading
  loading: false,
  // 导出历史列表
  source: {
    list: [],
    total: 0,
  },
  query: {
    page: 1,
    pageNum: 10,
  },

  // 是否打开弹框
  visible: false,
  // 弹框样式 1 导入历史 0 导出历史
  temp: 1,
  record: {},
  // 是否打开操作记录弹框
  recordVisible: false,

  // MC报表
  reportList: []
};

export const state = initialState;

export const effects = {
  // 获取excel任务导出列表
  *fetchImportList({ payload }) {
    const { ...props } = payload;
    yield put({ type: 'down/setState', payload: { loading: true, query: props } });
    const res = yield call(downApi.requestImportList, props);
    if (res && !Number(res.err)) {
      yield put({
        type: 'down/setState',
        payload: {
          source: {
            list: res.list || [],
            total: Number(res.list_num || 0),
          },
        },
      });
      yield put({ type: 'down/setState', payload: { loading: false } });
    }
  },
  // 获取任务excel下载地址
  *fetchImportTask({ payload }) {
    const res = yield call(downApi.requestImportTask, payload);
    if (res && res.url) {
      message.info($t('web_exporting_tips', 'Import'));
      const link = document.createElement('a');
      // link.target = '_blank';
      link.href = res.url.includes('https') ? res.url : res.url.replace('http', 'https');
      link.style.display = 'none';
      document.body.appendChild(link); // 兼容firefox
      link.click();
      link.remove();
    }
  },

  // 获取mc报表列表
  *fetchReportList(){
    const res = yield call(downApi.requestReportList);
    yield put({
      type: 'down/setState',
      payload: {
        reportList: res?.result?.data ?? []
      },
    });
  },
  // 导出mc报表
  *exportReport({payload}) {
    const res = yield call(downApi.requestReportExport, payload);
    return res
  }
};

export const reducers = {};
